import React, {useEffect, useState} from "react";
import {useStore} from "../../hooks/useStore";
import {useObserver} from "mobx-react-lite";
import {useFetch} from "../../hooks/useFetch";
import {Button} from "antd";
import JSONInput from "react-json-editor-ajrm";
import {AppConfigText, SaveButton} from "./appConfigPageStyles";
import {useTranslation} from "react-i18next";

export const AppConfigPage = () => {
    const stores = useStore();
    const {t} = useTranslation();
    const [jsonData, setJsonData] = useState();
    const [appConfigId, setAppConfigId] = useState();
    const [loading, appConfig, setAppConfig, setLoading] = useFetch({
        fetchFn: stores.appConfigStore.getAppConfig.bind(null, {})
    });

    useEffect(() => {
        setJsonData(appConfig.data?.configData);
        appConfig?.data?._id && setAppConfigId(appConfig?.data?._id);
    }, [appConfig]);

    const onSubmit = async () => {
        if (appConfigId) {
            await stores.appConfigStore.updateAppConfig({jsonData, appConfigId});
        } else {
            await stores.appConfigStore.createAppConfig({jsonData});
        }
    };

    const onChangeJSON = data => {
        setJsonData(data.jsObject);
    };

    return useObserver(() => (
        <React.Fragment>
            {stores.meStore.checkRole("appConfig") && (
                <div>
                    <AppConfigText>App Config</AppConfigText>
                    <JSONInput
                        id="JsonEditor"
                        placeholder={jsonData}
                        onChange={data => onChangeJSON(data)}
                        theme={"light_mitsuketa_tribute"}
                        width="100%"
                        height="400px"
                    />
                    <Button onClick={onSubmit} style={{width: "100%", marginTop: "1em"}}>
                        {t("actions.save", {ns: "common"})}
                    </Button>
                </div>
            )}
        </React.Fragment>
    ));
};
